import { useEffect, useState } from 'react';
import styles from './CookieConsent.module.scss';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Verifica se o usuário já aceitou os cookies
        const cookieConsent = localStorage.getItem('decatron-cookie-consent');
        if (!cookieConsent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        // Salva a confirmação no localStorage
        localStorage.setItem('decatron-cookie-consent', 'accepted');
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className={styles.cookie_consent}>
            <div className={styles.cookie_content}>
                <p className={styles.cookie_message}>
                    Este site não utiliza cookies próprios para coleta de dados. Cookies de
                    terceiros podem ser gerados apenas em páginas com conteúdo incorporado do
                    YouTube.
                </p>
                <button className={styles.cookie_button} onClick={handleAccept}>
                    Ciente
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
